<!-- DESKTOP -->
<div *ngIf="block" class="border-none h-100 bg-support-99 d-none overflow-hidden d-lg-flex flex-lg-row no-print" [ngClass]="{
        'flex-lg-nowrap w-100': idx === 0,
        'flex-lg-wrap align-items-lg-stretch': idx !== 0
    }">
    <!-- container img -->
    <div class="card__badge-container {{ idx === 0 ? 'me-3' : 'mb-1'}}" [ngClass]="{
            'col-lg-6': idx === 0,
            'col-lg-12': idx !== 0
        }" [ngStyle]="{'height': idx === 0 ? 'auto' : '200px'}">
        <img loading="lazy" *ngIf="block.field_immagine" [src]="imgPath" class="card__badge-container__card-img rounded"
            [alt]="image_alt">
        <div *ngIf="block.field_tags" class="card__badge-container__badge">
            {{block.field_created_at | localizedDate: 'd MMMM yyyy'}}
        </div>
    </div>
    <!-- end container img -->
    <!-- container text -->
    <div class="rounded card__card-body d-flex flex-column bg-neutral-A1 justify-content-between {{idx === 0 ? '' : 'mt-1'}}"
        [ngClass]="{
            'col-lg-6': idx === 0,
            'col-lg-12': idx !== 0
        }">
        <div>
            <div *ngIf="block.field_tags"
                class="rounded card__card-body__category d-flex justify-content-between align-items-center">
                <p class="m-0 text-neutral-60 ls-label-small-semibold">
                    <!-- <span class="me-2" *ngFor="let item of block.field_tags; let idx = index">
                        {{ block.field_tags.length - 1 === idx ? item.name : item.name + ',' }}
                    </span> -->
                    <span *ngIf="stringTags">{{ stringTags }}</span>
                </p>
                <i *ngIf="idx === 0" class="fa fa-light fa-share-nodes text-warning fs-4"></i>
            </div>
            <div *ngIf="objTitle" class="card__card-body__card-text">
                <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                    <h3 class="text-brand-10 mb-3 text-decoration-none" [hreflang]="objTitle.hreflang" [ngClass]="{
                        'ls-h3-item-title': idx === 0,
                        'ls-h3-item-title-small': idx !== 0
                    }" [innerHTML]="objTitle.title"></h3>
                </a>
                <a *ngIf="isLinkEsternal" [href]="objTitle.link" target="_blank">
                    <h3 class="text-brand-10 mb-3 text-decoration-none" [hreflang]="objTitle.hreflang" [ngClass]="{
                        'ls-h3-item-title': idx === 0,
                        'ls-h3-item-title-small': idx !== 0
                    }" [innerHTML]="objTitle.title"></h3>
                </a>
                <p *ngIf="block.field_sottotitolo" class="mb-5 text-neutral-40 ls-p-small"
                    [innerHTML]="block.field_sottotitolo"></p>
            </div>
        </div>
        <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
            <div class="rounded card__card-body__cta">
                <div
                    class="m-0 ls-label-medium-semibold card__card-body__cta__text text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
        <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
            <div class="rounded card__card-body__cta">
                <div
                    class="m-0 ls-label-medium-semibold card__card-body__cta__text text-brand-40 line-discover-with-icon">
                    <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
    </div>
    <!-- end container text -->
</div>
<!-- END DESKTOP -->
<!-- MOBILE -->
<div class=" d-block d-lg-none no-print">
    <!-- container img -->
    <div *ngIf="block" class="card card-mobile border-none bg-support-99">
        <div class="card-mobile__badge-container" style="height: 200px">
            <img loading="lazy" *ngIf="block.field_immagine" [src]="imgPath" class="card-mobile__badge-container__card-img rounded"
                [alt]="image_alt" style="height: 200px;">
            <div *ngIf="block.field_tags"
                class="card-mobile__badge-container__badge ls-label-small-semibold text-neutral-a1">
                {{block.field_created_at | localizedDate: 'd MMMM yyyy'}}</div>
        </div>
    </div>
    <!-- end container img -->
    <!-- container text -->
    <div class="rounded card-mobile__card-body card-body d-flex flex-column justify-content-between bg-white">
        <div *ngIf="block.field_tags"
            class="card-mobile__card-body__category d-flex justify-content-between align-items-center">
            <p class="m-0">
                <span class="me-2 ls-label-small-semibold text-neutral-60"
                    *ngFor="let item of block.field_tags; let idx = index">{{ block.field_tags.length - 1 === idx ?
                    item.name : item.name + ',' }}</span>
            </p>
        </div>
        <div *ngIf="objTitle">
            <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                <h3 class="card-mobile__card-body__card-title card-title mb-3 text-decoration-none ls-h3-item-title-small text-brand-10"
                    [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></h3>
            </a>
            <a *ngIf="isLinkEsternal" [href]="objTitle.link" target="_blank">
                <h3 class="card-mobile__card-body__card-title card-title mb-3 text-decoration-none ls-h3-item-title-small text-brand-10"
                    [hreflang]="objTitle.hreflang" [innerHTML]="objTitle.title"></h3>
            </a>
            <!-- <p *ngIf="block.field_sottotitolo" class="card-mobile__card-body__card-text card-text mb-5" [innerHTML]="block.field_sottotitolo"></p>     -->
        </div>
        <a *ngIf="objTitle && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
            <div class="rounded card-mobile__card-body__cta">
                <div
                    class="m-0 ls-label-medium-semibold card-mobile__card-body__cta__text text-brand-40 line-discover-with-icon">
                    <p>{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
        <a *ngIf="objTitle && isLinkEsternal" [href]="objTitle.link">
            <div class="rounded card-mobile__card-body__cta">
                <div
                    class="m-0 ls-label-medium-semibold card-mobile__card-body__cta__text text-brand-40 line-discover-with-icon">
                    <p>{{"FIND_OUT" | translate}}</p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </div>
        </a>
    </div>
    <!-- end container text -->
</div>
<!-- END MOBILE -->
<app-sample-print 
    [imageUrl]="block.field_immagine ? imgPath : ''"
    [taxonomy]="block.field_tags ? stringTags : ''"
    [title]="objTitle.title"
    [subtitle]="block.field_sottotitolo">
</app-sample-print>